module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJBAMAAADJBLEBAAAAG1BMVEXMzMyWlpacnJzFxcWqqqqjo6O+vr63t7exsbHk3kcxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAMklEQVQImWNgwA0UTJwZGDjcGRgEwoyBDCMgQ1WZo4wjEcgQS2cO4FAFMlqcgSJuCE0ApZcFqTBC50oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/16x9.png
// module id = 123
// module chunks = 2